export function TermsOfService() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
      <div className="prose prose-indigo">
        <p className="text-lg mb-6">Last updated: {new Date().toLocaleDateString()}</p>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">1. Agreement to Terms</h2>
          <p>By accessing or using VZMO.AI, you agree to be bound by these Terms of Service and all applicable laws and regulations.</p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">2. Use License</h2>
          <p>We grant you a personal, non-transferable, non-exclusive license to use VZMO.AI for personal or business purposes in accordance with these Terms.</p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">3. Subscriptions</h2>
          <ul className="list-disc pl-6 mb-4">
            <li>Subscription fees are billed in advance on a monthly or annual basis</li>
            <li>You may cancel your subscription at any time</li>
            <li>Refunds are handled according to our refund policy</li>
          </ul>
        </section>

        <section className="mb-8" id="refunds">
          <h2 className="text-2xl font-semibold mb-4">4. Refund Policy</h2>
          <div className="bg-gray-50 p-6 rounded-lg">
            <h3 className="text-lg font-medium mb-4">Trial Period</h3>
            <p className="mb-4">Your subscription begins with a 7-day free trial. During this period:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>You can cancel at any time without charge</li>
              <li>No payment will be processed until the trial ends</li>
              <li>You will receive a reminder before the trial expires</li>
            </ul>

            <h3 className="text-lg font-medium mb-4">Subscription Refunds</h3>
            <p className="mb-4">After the trial period:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>Monthly subscriptions are non-refundable but can be cancelled anytime</li>
              <li>Annual subscriptions may be eligible for a prorated refund within the first 30 days</li>
              <li>Cancellations take effect at the end of the current billing period</li>
            </ul>

            <h3 className="text-lg font-medium mb-4">Special Circumstances</h3>
            <p className="mb-4">We may consider refunds in exceptional cases:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>Technical issues preventing service access</li>
              <li>Billing errors or unauthorized charges</li>
              <li>Service unavailability exceeding 24 hours</li>
            </ul>

            <p className="text-sm text-gray-600">
              To request a refund, please contact our support team at support@vzmo.ai with your account details and reason for the request.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">5. User Responsibilities</h2>
          <p>You are responsible for:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Maintaining the confidentiality of your account</li>
            <li>All activities that occur under your account</li>
            <li>Ensuring your content doesn't violate any laws or rights</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">6. Intellectual Property</h2>
          <p>All content, features, and functionality of VZMO.AI are owned by us and are protected by international copyright, trademark, and other intellectual property laws.</p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">7. Limitation of Liability</h2>
          <p>VZMO.AI shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use the service.</p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">8. Changes to Terms</h2>
          <p>We reserve the right to modify these terms at any time. We will notify you of any material changes via email or through the platform.</p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">9. Contact</h2>
          <p>Questions about the Terms of Service should be sent to us at support@vzmo.ai</p>
        </section>
      </div>
    </div>
  );
}